import React, { useState } from 'react';
import NavBarComponent from "../../components/navBar/NavBarComponent";
import FooterComponent from "../../components/home/FooterComponent";
import MainSolutionsComponent from "../../components/solutions/mainSolutionsHome/mainSolutionsComponent";

export default function MainSolutionsPage(props) {

    return (
        <div>

            <NavBarComponent />
            <MainSolutionsComponent />
            <FooterComponent />
        </div>
    );
};

